import { render, staticRenderFns } from "./address-list.vue?vue&type=template&id=4029d096&"
import script from "./address-list.vue?vue&type=script&lang=js&"
export * from "./address-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports